import AbstractTracker from './AbstractTracker';

class CombinedTracker extends AbstractTracker {
  constructor (trackers = []) {
    super();
    this.trackers = trackers;
  }

  setUser () {
    this.trackers.forEach(tracker => tracker.setUser(...arguments));
  }

  setRole () {
    this.trackers.forEach(tracker => tracker.setRole(...arguments));
  }

  track () {
    const promises = this.trackers.map(tracker => tracker.track(...arguments));
    return Promise.all(promises);
  }

}

export default CombinedTracker;
